import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: `${_ctx.itemForm?.form_name}`,
    modelValue: _ctx.dialogResF2,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogResF2) = $event)),
    "close-on-click-modal": false,
    class: "bg-light rounded",
    top: "2vh",
    fullscreen: true,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.tabName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabName) = $event)),
        type: "border-card",
        class: "demo-tabs",
        style: _normalizeStyle(`height: ${_ctx.altura-200}px;`)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "Filtro por deporte",
            name: "first"
          }, {
            default: _withCtx(() => [
              _createTextVNode("User")
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Filtro por país",
            name: "second"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Config")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "style"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpened", "onClosed"]))
}